// Sample configuration for a survey with all possible configuration options.

const surveyConfig = {
	type: 'sample',   		// Type name of survey, alphanumeric with underscores
	mode: 'tabbed',			// Mode of survey, single/tabbed. TODO: Only tabbed is implemented for now.
	cols: 1,				// Number of columns in the form root or tabbed roots.
	title: "",
    disableHeaderImage: false,
    linkHeaderImage: null,
    // replaceHeaderImage: require('@/assets/replacement_header.png'),
	tabs: [
		{ key: 'basic', title: 'Basic Information' },
	],
    forceInitialize: {      // Key-value pairs to force initialization in applicationData.
        'empty_array': [],
    },
	intro: { 
		label: "Introduction",
		title: "Our goal is to help you find the best job opportunities in Germany",
		//video: require('@/assets/general_survey_vid.mp4'),
		//videoThumb: require('@/assets/general_survey_vid.th.jpg'),
		description: "Lorem Ipsum.\n" +
			"Lorem Ipsunm.",
        //descriptionLogo: require('@/assets/uni_iloilo_logo.png'),
        //descriptionRaw: "<b>Raw html output</b>",
        // containerStyles: "border: none;",
        whoAreWe: [
            {
                //logo: require('@/assets/90niner_logo.jpg'),
                title: 'Company name',
                description: 'is a leading review and testing center.',
            },
            {
                //logo: require('@/assets/colpuno_logo.png'),
                raw: '<b>Company</b> – <i>slogan</i> – is building the first comprehensive digital marketplace.',
            },
        ],
        showPrivacy: false,     // Show privacy policy checkbox in introduction section as well.
        // nextBtnText: "Next",
        // nextBtnHighlight: true,
	},
	conclusion: {
        showInviter: false,     // Show additional inviter text box in conclusion section for email gathering.
        // inviterLabel: 'Who else do you know who would be interested in this survey?',
        useInviterArray: false, // If we use the RatedTopics component for the inviter rather than a simple text box.
		label: "Conclusion",
		title: "Thank you for completing the survey!",
        subtitle: "Subtitle",
		description: "Lorem Ipsum.\n" +
			"Lorem Ipsum.",
		ctaTitle: "Would you like to sign up for the beta phase of our services?",
		ctaDescription: "Yes, I would like to participate in a possible Beta platform.",
		ctaAdditional: "If you'd prefer not to participate, please unselect this option.",
        ctaGatherEmail: false,      // If true, add an email input field to the CTA section if CTA is agreed to.
		ending: "Thank you for your valuable contribution!",
        privacy_custom: "/privacy_uni_iloilo_v1.html",      // Link instead to custom privacy policy
        privacy_extras: "",    // Additional italic text below privacy policy checkbox text.
	},
    finished: {
        tick: true,             // Show tick icon or not
        title: "Thank you for sharing your opinion.",
        description: "Lorem Ipsum.",
        raw: "<pre><u>Raw html output</u></pre>",
        clickthru: {
            logo: '',
            text: '',
            link: '',
        },
        raffle: {
            enabled: true,      // If raffle is enabled, an 'email' field MUST exist which is used as unique key in the survey. The keys 'full_name' or 'name' are optionally used for displaying names of winners.
        },
    },
};

// Note: We only support groups in the top level form, and everything MUST be in a group.
// This is because devextreme does not support using simpleitems/groupitems in sub-components of Vue. (See: https://supportcenter.devexpress.com/ticket/details/t1045156/form-dxsimpleitem-into-custom-component)
// This makes it impossible to use a custom component and allow recursive items/inputs, etc.
const surveyFields = [];

// Tab 1
surveyFields.push({ key: 'demographic', tab: 'demographic', type: 'group', label: "Demographic Information", cols: 2, items: [
    { key: 'first_name', type: 'text', label: "First name", required: true },
    { key: 'last_name', type: 'text', label: "Family name", required: true },
]});

export default { surveyConfig, surveyFields };